import { Box } from '@mui/material';
import Drawer from '@mui/material/Drawer';

// type Anchor = 'top' | 'left' | 'bottom' | 'right';

interface Props {
    open: boolean;
    children?: JSX.Element;
    handleClose: () => void;
    width?: number;
    zIndex?: number;
}

export const DrawerRight = ({ 
    open, 
    handleClose, 
    children, 
    width = 300,
    zIndex=2000
}: Props) => {


    return (

        <Drawer
            anchor='right'
            open={open}
            onClose={handleClose}
            sx={{
                zIndex,
            }}
        >
            <Box
                sx={{ width, p:2 }}
                role="presentation">
                {children}
            </Box>
        </Drawer>


    );
}